import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  DatePicker,
  Alert,
  Select,
  Table,
  Tooltip,
  Icon,
  message,
} from "antd";
import { formatNumber, getCurrencySymbol } from "../../../../Helpers/Pricing";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import { hasPermission } from "../../../../Helpers/Permissions";
import { SHOPIFY_NAME } from "../../../../constants";
import "./index.scss";
import qs from "qs";

const { RangePicker } = DatePicker;
const { Option } = Select;

const status = {
  rto: "RTO",
  delivered: "Delivered",
  transit: "In Transit",
};

const remittanceStatus = {
  pending: "Pending",
  processed: "Processed",
};

const columnData = {
  vforderid: {
    width: "150px",
    title: "vF Order Id",
    dataIndex: "vforderid",
    sortValue: 1,
  },
  shopify_order_name: {
    width: "150px",
    title: "Shopify Order Name",
    dataIndex: "shopify_order_name",
    sortValue: 2,
  },
  shopify_order_date: {
    width: "150px",
    title: `${SHOPIFY_NAME} Order Date`,
    dataIndex: "shopify_order_date",
    sortValue: 3,
    render: (_, row) => (
      <p>{moment(row.order_filterdate).format("DD MMM, YYYY")}</p>
    ),
  },
  shopify_store_name: {
    width: "150px",
    title: "Shopify Store Name",
    dataIndex: "shopify_store_name",
    sortValue: 4,
  },
  payment_type: {
    width: "150px",
    title: "Payment Type",
    dataIndex: "payment_type",
    sortValue: 5,
  },
  shipment_delivery_date: {
    width: "150px",
    title: "Shipment Delivery Date",
    dataIndex: "shipment_delivery_date",
    sortValue: 6,
    render: (shipment_delivery_date) =>
      shipment_delivery_date ? (
        <p>{moment(shipment_delivery_date).format("DD MMM, YYYY")}</p>
      ) : (
        "NA"
      ),
  },
  vf_order_date: {
    width: "150px",
    title: "vF Order Date",
    dataIndex: "vf_order_date",
    sortValue: 7,
    render: (date) => <p>{moment(date).format("DD MMM, YYYY")}</p>,
  },
  waybill_number: {
    width: "150px",
    title: "WayBill Number",
    dataIndex: "waybill_number",
    sortValue: 8,
  },
  transaction_id: {
    width: "150px",
    title: "Transaction ID",
    dataIndex: "transaction_id",
    sortValue: 9,
  },
  current_status: {
    width: "150px",
    title: "Current Status",
    dataIndex: "current_status",
    sortValue: 10,
    render: (current_status) => Object.values(status[current_status]),
  },
  collection_amount: {
    width: "150px",
    title: "COD Amount",
    dataIndex: "collection_amount",
    sortValue: 11,
    render: (amount) => (
      <p>
        {getCurrencySymbol("INR")} {formatNumber(amount)}
      </p>
    ),
  },
  remittance_status: {
    width: "150px",
    title: "Remittance Status",
    dataIndex: "remittance_status",
    sortValue: 12,
    render: (remittance_status) =>
      remittance_status ? remittanceStatus[remittance_status] : "NA",
  },
  credit_date: {
    width: "150px",
    title: "Credit Date",
    dataIndex: "credit_date",
    sortValue: 13,
    render: (date) => <p>{moment(date).format("DD MMM, YYYY")}</p>,
  },
};

const defaultCols = [
  "vforderid",
  "waybill_number",
  "current_status",
  "payment_type",
  "collection_amount",
  "remittance_status",
  "transaction_id",
  "credit_date",
];

class VfRemittanceMIS extends Component {
  state = {
    currency: "INR",
    stats: {
      totalremittance: 0,
      totalremitprocess: 0,
      totalremitpending: 0,
      total_orders: 0,
    },
    filters: {
      startDate: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    paging: {
      page: 1,
      pageSize: 10,
      total: 0,
    },

    loading: false,
    error: false,
    errorMsg: "",
    orders: [],
    columns: defaultCols.map((c) => columnData[c]),
    statsLoading: false,
  };

  componentDidMount() {
    this.getOrders();
    this.getStats();
  }

  getOrders() {
    this.setState(
      {
        loading: true,
      },
      () => {
        axios({
          url: process.env.REACT_APP_API_URL + "/reporting/get_shipments",
          method: "post",
          data: {
            storeid: this.props.match.params.storeid,
            page: this.state.paging.page,
            pageSize: this.state.paging.pageSize,
            filters: this.state.filters,
            type: "cod",
          },
          withCredentials: true,
        })
          .then((res) => {
            if (res.data.success === 1) {
              this.setState({
                orders: res.data.orders,
                loading: false,
                error: false,
                errorMsg: "",
                paging: { ...this.state.paging, total: res.data.total },
              });
            } else {
              this.setState({
                error: true,
                errorMsg: res.data.msg,
                loading: false,
              });
            }
          })
          .catch((e) => {
            this.setState({
              error: true,
              errorMsg: e.message,
              loading: false,
            });
          });
      }
    );
  }

  getStats() {
    this.setState(
      {
        statsLoading: true,
      },
      () => {
        axios({
          url: process.env.REACT_APP_API_URL + "/reporting/vf_remittance_mis",
          method: "post",
          data: {
            storeid: this.props.match.params.storeid,
            filters: this.state.filters,
          },
          withCredentials: true,
        })
          .then((res) => {
            if (res.data.success === 1) {
              this.setState({
                statsLoading: false,
                stats: {
                  total_orders: res.data.stats.total_orders,
                  totalremittance: res.data.stats.total_remittance,
                  totalremitprocess: res.data.stats.total_remittance_processed,
                  totalremitpending: res.data.stats.total_remittance_pending,
                },
              });
            } else {
              this.setState({
                statsLoading: false,
              });
              message.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.setState({
              statsLoading: false,
            });
            message.error(e.message);
          });
      }
    );
  }

  filterChanged() {
    this.getOrders();
    this.getStats();
  }

  handleChange(value) {
    this.setState({
      columns: value
        .map((c) => columnData[c])
        .sort((a, b) => a.sortValue - b.sortValue),
    });
  }

  unselectColumn(index) {
    this.setState({
      columns: this.state.columns
        .filter((_, i) => i !== index)
        .sort((a, b) => a.sortValue - b.sortValue),
    });
  }

  goToPage = (page) => {
    this.setState(
      {
        paging: { ...this.state.paging, page: page.current },
      },
      () => this.getOrders()
    );
  };

  render() {
    const { store } = this.props;
    const PageWrapper = (children) => {
      return (
        <div className="remittance">
          <Row>
            <div className="heading">
              <h1 className="content-page-title" style={{ marginBottom: 0 }}>
                vF Remittance MIS
              </h1>
              <h3
                className="content-page-subtitle"
                style={{ marginBottom: 30 }}
              >
                COD Remittance for Orders in The Selected Period
                <span style={{ float: "right", marginTop: "-4px" }}>
                  Show data from:
                  <RangePicker
                    disabledDate={(current) => {
                      return current > moment();
                    }}
                    value={[
                      this.state.filters.startDate === ""
                        ? null
                        : moment(this.state.filters.startDate),
                      this.state.filters.endDate === ""
                        ? null
                        : moment(this.state.filters.endDate),
                    ]}
                    ranges={{
                      "Last Month": [
                        moment()
                          .subtract(1, "months")
                          .startOf("month"),
                        moment()
                          .subtract(1, "months")
                          .endOf("month"),
                      ],
                      "Last 3 Month": [
                        moment()
                          .subtract(2, "months")
                          .startOf("month"),
                        moment().endOf("month"),
                      ],
                    }}
                    onChange={(_, dateString) =>
                      this.setState(
                        {
                          filters: {
                            startDate: dateString[0],
                            endDate: dateString[1],
                          },
                        },
                        () => this.filterChanged()
                      )
                    }
                  />
                </span>
              </h3>
            </div>
          </Row>
          {children}
        </div>
      );
    };

    if (!this.state.loading && this.state.error) {
      return PageWrapper(
        <Row>
          <Alert
            message="There was an error"
            description={this.state.errorMsg}
            type="error"
          />
        </Row>
      );
    }

    const order_stats = {
      totalremittance: "Total Remittance",
      totalremitprocess: "Total Remittance Processed",
      totalremitpending: "Total Remittance Pending",
    };
    const tooltip = {
      totalremittance: "Total Remittance",
      totalremitprocess: "Total Remittance Processed",
      totalremitpending: "Total Remittance Pending",
    };

    const pagination = {
      current: this.state.paging.page,
      pageSize: this.state.paging.pageSize,
      total: this.state.paging.total,
    };

    return PageWrapper(
      <React.Fragment>
        <Row gutter={{ lg: 30 }}>
          <Col xs={24} md={24} lg={24} xl={24} style={{ marginBottom: 56 }}>
            <Card className="reporting-card" loading={this.state.statsLoading}>
              <div className="header" style={{ textAlign: "center" }}>
                Total Orders
              </div>
              <div className="body" style={{ textAlign: "center" }}>
                {this.state.stats.total_orders}
              </div>
            </Card>
          </Col>
        </Row>
        <Row gutter={{ lg: 30 }}>
          {Object.keys(order_stats).map((k) => (
            <Col
              xs={24}
              md={12}
              lg={8}
              xl={8}
              style={{ marginBottom: 56 }}
              key={k}
            >
              <Card
                className="reporting-card"
                loading={this.state.statsLoading}
              >
                <div className="header">
                  {order_stats[k]}
                  <span className="header-tooltip">
                    <Tooltip title={tooltip[k]}>
                      <Icon type="exclamation-circle-o" />
                    </Tooltip>
                  </span>
                </div>
                <div className="body">
                  {getCurrencySymbol(this.state.currency)}{" "}
                  {formatNumber(this.state.stats[k])}
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        <Row>
          <div className="heading">
            <h1 className="content-page-title" style={{ marginBottom: "10px" }}>
              COD Remittance Analysis Data
              <span style={{ float: "right" }}>
                {hasPermission(store, "export_cod_remittance_report") && (
                  <a
                    href={`/reporting/vf_remittance_mis_csv?${qs.stringify(
                      {
                        storeid: this.props.match.params.storeid,
                        filters: this.state.filters,
                        columns: this.state.columns.map((c) => c.dataIndex),
                      },
                      { encodeValuesOnly: true }
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: "#25BE05",
                      border: "none",
                      color: "white",
                    }}
                    className="ant-btn"
                  >
                    <Icon type="download" /> Download CSV
                  </a>
                )}
              </span>
            </h1>
          </div>
        </Row>
        <Row>
          <div className="selected-column">
            <h3 className="content-page-subtitle">Display Columns : </h3>
            <Select
              mode="multiple"
              placeholder="Select from dropdown"
              value={this.state.columns.map((column) => `${column.dataIndex}`)}
              onChange={(value) => this.handleChange(value)}
              className="display-column-select"
            >
              {Object.values(columnData).map((c) => (
                <Option value={c.dataIndex} key={c.dataIndex}>
                  {c.title}
                </Option>
              ))}
            </Select>
          </div>
        </Row>
        <Row style={{ marginBottom: "30px" }}>
          {this.state.columns.map((column, i) => (
            <div className="selectedValue" key={i}>
              {column.title}{" "}
              <Icon type="close" onClick={() => this.unselectColumn(i)} />
            </div>
          ))}
          <div />
        </Row>
        <Row>
          <Table
            columns={this.state.columns}
            dataSource={this.state.orders}
            loading={this.state.loading}
            rowKey={(row) => row.awb}
            onChange={(page) => this.goToPage(page)}
            scroll={{ x: 175 * this.state.columns.length }}
            pagination={{
              ...pagination,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Row>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    store: state.auth.auth.store,
  };
};
export default connect(mapStateToProps)(VfRemittanceMIS);
